import { render, staticRenderFns } from "./MainEl.vue?vue&type=template&id=3e872106&lang=pug&"
import script from "./MainEl.vue?vue&type=script&lang=js&"
export * from "./MainEl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports